import { mergeDateValue, mergeTimeValue } from "../../utility/date.helpers";
import { VALIDATION_MODE_AFTER_CHANGE, VALIDATION_MODE_AFTER_ERROR_CHANGE } from "../validation";

const getNewFieldValue = (node, value, controlType, isValidDate, isDateTime) => {
    if ((controlType === 'datePicker' || controlType === 'timePicker') && value) {
        const oldValue = node.value();

        if (controlType === 'datePicker') {
            return mergeDateValue(oldValue, isValidDate, value, isDateTime);
        }
        
        return mergeTimeValue(oldValue, value);
    }

    return value;
};

const fieldChangeActionHandler = (validationInst, renderViewAsync, getNodeForNodeId) => {

    // string, string -> Promise
    const updateNodeByNodeIdAsync = async (nodeId, value, controlType, isValidDate, isRichTextString, isDateTime) => {
        const node = getNodeForNodeId(nodeId);

        if (!node) {
            console.error("Unable to find node with id ", JSON.stringify(nodeId));

            return;
        }

        const newValue = getNewFieldValue(node, value, controlType, isValidDate, isDateTime);

        return node.setValueAsync(newValue, { isRichTextString });
    }

    // Handles a field change event from the page DOM
    // EventInfo -> Promise[void]
    const handleFieldChangeAsync = async ({ props, controlType }) => {
        const { formatType, hasValidationError } = props;
        const isDateTime = (formatType === 'datetime');

        await updateNodeByNodeIdAsync(
            props.nodeId,
            props.newValue,
            controlType,
            props.isValidDate,
            props.isRichText,
            isDateTime,
        );

        const validationMode = validationInst.getMode();

        const shouldValidateAll =
            validationMode === VALIDATION_MODE_AFTER_CHANGE ||
            (validationMode === VALIDATION_MODE_AFTER_ERROR_CHANGE && hasValidationError)

        if (shouldValidateAll) {
            validationInst.validateAll();
        }

        await renderViewAsync();
    }

    return {
        handleFieldChangeAsync,
    };
};


export default fieldChangeActionHandler;